import { render, staticRenderFns } from "./SelectorFechaHorav2.vue?vue&type=template&id=2dd77a28&"
import script from "./SelectorFechaHorav2.vue?vue&type=script&lang=js&"
export * from "./SelectorFechaHorav2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports